import React, { memo } from 'react';
import { Grid, MenuItem } from '@mui/material';
import FormTextField from './FormTextField';
import FormSelectField from './FormSelectField';

const FormPhoneField = memo(
  ({
    name,
    label,
    formik,
    required,
    error,
    helperText,
    onBlur,
    onChange,
    codigosPais,
    codigoWidth = '40%',
    numeroWidth = '60%',
  }) => {
    // Obtener los valores del objeto teléfono
    const phoneValue = formik.values[name] || { codigo: '+54', numero: '' };
    const codigoValue = phoneValue.codigo;
    const numeroValue = phoneValue.numero;

    // Obtener los errores específicos para cada campo
    const codigoError = formik.touched[`${name}.codigo`] && formik.errors[`${name}.codigo`];
    const numeroError = formik.touched[`${name}.numero`] && formik.errors[`${name}.numero`];

    // Manejar cambios en el código de país
    const handleCodigoChange = (e) => {
      const newValue = e.target.value;
      formik.setFieldValue(`${name}.codigo`, newValue, true);
      // Actualizar el objeto completo
      formik.setFieldValue(
        name,
        {
          ...phoneValue,
          codigo: newValue,
        },
        true
      );
      onChange?.(e);
    };

    // Manejar cambios en el número
    const handleNumeroChange = (e) => {
      const newValue = e.target.value;
      formik.setFieldValue(`${name}.numero`, newValue, true);
      // Actualizar el objeto completo
      formik.setFieldValue(
        name,
        {
          ...phoneValue,
          numero: newValue,
        },
        true
      );
      onChange?.(e);
    };

    // Manejar blur en ambos campos
    const handleBlur = (e) => {
      formik.handleBlur(e);
      onBlur?.(e);
    };

    // Convertir el objeto de códigos de país en un array para el select
    const phoneCodesArray = Object.entries(codigosPais || {}).map(([value, label]) => ({
      value,
      label,
    }));

    return (
      <Grid container spacing={2}>
        <Grid item md={4} sx={{ width: codigoWidth }} xs={12}>
          <FormSelectField
            error={codigoError}
            formik={formik}
            label='Código'
            name={`${name}.codigo`}
            onBlur={handleBlur}
            onChange={handleCodigoChange}
            required={required}
            value={codigoValue}
          >
            {phoneCodesArray.map((codigo) => (
              <MenuItem key={codigo.value} value={codigo.value}>
                {codigo.label}
              </MenuItem>
            ))}
          </FormSelectField>
        </Grid>
        <Grid item md={8} sx={{ width: numeroWidth }} xs={12}>
          <FormTextField
            error={numeroError}
            formik={formik}
            helperText={typeof helperText === 'string' ? helperText : ''}
            inputType='numeric'
            label={label}
            name={`${name}.numero`}
            onBlur={handleBlur}
            onChange={handleNumeroChange}
            placeholder='Ingrese el número'
            required={required}
          />
        </Grid>
      </Grid>
    );
  }
);

FormPhoneField.displayName = 'FormPhoneField';

export default FormPhoneField;
